import { type IContentElementProps } from '@secretescapes/cauldron';

interface DispatchTrackingEventArgs<T> {
  name: string;
  contentElement: IContentElementProps;
  details: T;
}

export const dispatchTrackingEvent = <T>({
  name,
  contentElement,
  details,
}: DispatchTrackingEventArgs<T>) => {
  const trackingEvent = new CustomEvent(name, {
    detail: {
      contentElement: {
        ...contentElement,
        ...details,
      },
    },
  });

  window.dispatchEvent(trackingEvent);
};
